import { useEffect, useState } from "react";
import { IconClose, IconHamberger } from "../../Assets/Icons";

interface NavbarProps {
  currentPage: string;
  isMenuOpen: boolean;
  handleMenuClick: (page: string) => void;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MENU_ITEMS = ["Beranda", "Donasi Barang", "Campaign ", "Galang Dana", "Berita"];

const Navbar: React.FC<NavbarProps> = ({ currentPage, isMenuOpen, handleMenuClick, setIsMenuOpen }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Helper warna desktop
  const desktopTextColor = isScrolled ? "text-black" : "text-white";
  const desktopHoverColor = "hover:text-[#f88434]";

  return (
    <header
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[95%] md:w-[90%]
        rounded-3xl px-3 py-2 lg:px-5 flex justify-between items-center
        transition-all duration-300
        ${isScrolled ? "bg-white shadow-md backdrop-blur-md" : "bg-transparent"}
      `}>
      {/* LOGO */}
      <div className="flex items-center gap-2 ms-2">
        <img src="/images/logo_peduli.png" alt="Logo" className="w-14 h-14 md:w-16 md:h-16" />
      </div>

      {/* DESKTOP MENU */}
      <nav className="hidden lg:flex gap-6 items-center">
        {MENU_ITEMS.map((item) => {
          const isActive = currentPage === item;

          return (
            <div
              key={item}
              onClick={() => handleMenuClick(item)}
              className={`
                cursor-pointer px-3 py-1 rounded-full transition-all duration-300
                ${isActive ? "text-[#f88434] font-bold text-lg" : `${desktopTextColor} ${desktopHoverColor}`}
              `}>
              {item}
            </div>
          );
        })}
      </nav>

      {/* MOBILE TOGGLE */}
      <button className="lg:hidden z-50 text-black" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? "Close menu" : "Open menu"}>
        {isMenuOpen ? <IconClose /> : <IconHamberger />}
      </button>

      {/* MOBILE MENU */}
      <div
        className={`fixed top-0 left-0 w-full bg-white z-40 rounded-b-3xl
          transition-transform duration-300 ease-in-out
          ${isMenuOpen ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}
        `}>
        <div className="pt-24 pb-8 px-6 space-y-6 text-lg font-medium text-black">
          {MENU_ITEMS.map((item) => (
            <div
              key={item}
              onClick={() => {
                handleMenuClick(item);
                setIsMenuOpen(false);
              }}
              className="cursor-pointer hover:text-[#f88434] transition">
              {item}
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
